/** [recipient] 在 [states] props 中的 index */
export const index = {
  recipient: 0,
};
